import { createAsyncThunk } from "@reduxjs/toolkit";
import { URL_CITY_MUNICIPALITY } from "config/connString";
import useAxios from "utils/useAxios";

const getCityMunicipalities = createAsyncThunk(
  "citymunicipalities/get-citymunicipalities",
  async (data) => {
    try {
      const api = useAxios();
      const response = await api.get(URL_CITY_MUNICIPALITY + "/" + data.id);
      return response.data;
    } catch (err) {
      return err;
    }
  }
);

export { getCityMunicipalities };
